import { Injectable } from '@angular/core';
import { UserGeneratedWidgetConfig } from '../../../interfaces';
import { CustomWidgetService } from '../../classes/custom-widget-service';

@Injectable({
	providedIn: 'root',
})
export class UserGeneratedWidgetConfigService extends CustomWidgetService<UserGeneratedWidgetConfig> {
	protected override addWidgetsToBoard(
		boardId: string,
		widgets: UserGeneratedWidgetConfig[]
	): void {
		const boards = this.appSettingsService.webAppSettings.boards || [];
		const board = boards.find((b) => b.id === boardId);

		if (board?.userGeneratedWidgets) {
			board.userGeneratedWidgets = widgets;
		}
	}

	protected override getWidgetsById(id: string): UserGeneratedWidgetConfig[] {
		const boards = this.appSettingsService.webAppSettings.boards || [];
		const board = boards.find((b) => b.id === id);

		if (!board?.userGeneratedWidgets) {
			return [];
		}

		return board.userGeneratedWidgets;
	}

	protected override validateWidget(widget: UserGeneratedWidgetConfig): boolean {
		return !(!widget.id || !widget.headline || !widget.value);
	}

	protected override getTranslationKey(): string {
		return 'user_generated_widget';
	}
}
